/* eslint-disable @typescript-eslint/explicit-function-return-type */
import { useMutation } from "@tanstack/react-query";
import { format } from "date-fns";
import { notificarErroApi } from "utils/alertaCiencia";
import instance from "services/axiosServices";
import backofficeEnviroment from "utils/backofficeEnviroment";

interface Props {
  idEmpreendimento: string;
  idUnidade: string;
  idLeadCorretor: string;
  nomeComprador: string;
  valorCapacPagtoMensal: string;
  valorAprovadoFinanciamento: string;
  financiamentoUtilizado: string;
  fgtsUtilizado?: string;
  valorProposta: string | number;
  rendaFamiliar: string;
  valorFgts: string;
  subsidio?: string;
  idOportunidade?: string;
  ato?: string;
  anualSolicitada?: string;
  desconto?: string;
  beneficioExtra?: string;
}

export function useResumoPagamento() {
  function toNumber(valor: any) {
    if (typeof valor === "number") return valor;
    if (typeof valor !== "string") return NaN;

    const valorFormatado = valor.replace(/\./g, "").replace(",", ".");

    return parseFloat(valorFormatado);
  }
  const postData = async (props: Props) => {
    const RESUMO_PAGAMENTO = `${backofficeEnviroment}/common/oportunidades-lead/resumo-pagamento/vivaz/v1`;
    const payload: any = {
      IdEmpreendimento: props.idEmpreendimento,
      IdUnidade: props.idUnidade,
      ato: toNumber(props.ato),
      anualSolicitada: toNumber(props.anualSolicitada),
      desconto: toNumber(props.desconto),
      IdLeadCorretor: props.idLeadCorretor,
      NomeComprador: props.nomeComprador,
      ValorCapacPagtoMensal: toNumber(props.valorCapacPagtoMensal),
      ValorAprovadoFinanciamento: toNumber(props.valorAprovadoFinanciamento),
      FinanciamentoUtilizado: toNumber(props.financiamentoUtilizado),
      FgtsUtilizado: toNumber(props.fgtsUtilizado),
      ValorProposta: toNumber(props.valorProposta),
      RendaFamiliar: toNumber(props.rendaFamiliar),
      ValorFgts: toNumber(props.valorFgts),
      Subsidio: toNumber(props.subsidio),
      BeneficioExtra: toNumber(props.beneficioExtra),
    };

    // Inclui idOportunidade apenas se existir
    if (props.idOportunidade) {
      payload.idOportunidade = props.idOportunidade;
    }

    const { data } = await instance.post(RESUMO_PAGAMENTO, payload);
    return data;
  };

  const mutation = useMutation(postData, {
    retry: 1,
    onSuccess: () => {
      // toast.success("Resumo de pagamento inserido com sucesso!");
    },
    onError: (error: any) => {
      notificarErroApi("Erro ao inserir Resumo de pagamento", error);
    },
  });

  return mutation;
}
